module.exports = __webpack_public_path__ + "static/media/smoke.0960bb80.png";